import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import BandView from '@/views/BandView.vue';
import MediaView from '@/views/MediaView.vue';
import TourView from '@/views/TourView.vue';
import ContactView from '@/views/ContactView.vue';
import DiscographyView from '@/views/DiscographyView.vue';
import NewsView from '@/views/NewsView.vue';
import FanZone from '@/views/FanZone.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { transition: '' },
  },
  {
    path: '/band',
    name: 'BandView',
    component: BandView,
    meta: { transition: '' },
  },
  {
    path: '/discography',
    name: 'Discography',
    component: DiscographyView,
    meta: { transition: '' },
  },
  {
    path: '/media',
    name: 'Media',
    component: MediaView,
    meta: { transition: '' },
  },
  {
    path: '/tour',
    name: 'Tour',
    component: TourView,
    meta: { transition: '' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactView,
    meta: { transition: '' },
  },
  {
    path: '/news',
    name: 'News',
    component: NewsView,
    meta: { transition: '' },
  },
  {
    path: '/fanzone',
    name: 'FanZone',
    component: FanZone,
    meta: { transition: '' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
